import React from 'react'
import './footer.style.css'
import { TiSocialLinkedin } from 'react-icons/ti'
import { RiGithubLine } from 'react-icons/ri'
import { HIDE_SERVICE } from '../../utils/config'

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer_logo">
        {'</> |  VIVEK.PADELKAR'}
      </a>

      <ul className="gotoLinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        {HIDE_SERVICE && (
          <>
            <li>
              <a href="#services">Services</a>
            </li>
            <li>
              <a href="#tetimonial">Testimonials</a>
            </li>
          </>
        )}

        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="socials">
        <a href="#">
          <TiSocialLinkedin className="logo-icon" />
        </a>
        <a href="#">
          <RiGithubLine className="logo-icon" />
        </a>
      </div>

      <div className="copyright">
        <small>&copy; Vivek.padelkar All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
